export default __webpack_public_path__ + "static/media/kevin-team.733a1a27.webp";